<p-toast position="bottom-left"></p-toast>

<div *ngIf="code" class="expanded-content">
    <!-- Code Information Component -->
    <div class="mb-0">
      <app-code-information
        [mode]="isEditMode ? 'edit' : 'view'"
        [hcpcsCodeData]="codeDataWithCmsDates"
        [isExpandedViewEdit]="isEditMode"
        (formChange)="onCodeInfoChange($event)">
      </app-code-information>
    </div>
    
    <!-- Modifiers Component with built-in loading -->
    <div class="mb-0">
      <app-modifiers
        [mode]="isEditMode ? 'edit' : 'view'"
        [initialModifiers]="modifiersData"
        [planEffectiveStartDate]="planEffectiveStartDate"
        [planEffectiveEndDate]="planEffectiveEndDate"
        [cmsEffectiveStartDate]="cmsEffectiveStartDate"
        [cmsEffectiveEndDate]="cmsEffectiveEndDate"
        [hcpcsCode]="code?.code"
        [tenantId]="filters?.tenantId"
        [isLoading]="isLoadingModifiers">
      </app-modifiers>
    </div>
    
    <!-- Clinical Questionnaire Forms Component -->
    <div class="mb-1">
      <app-clinical-questionnaire-forms
        [mode]="isEditMode ? 'edit' : 'view'"
        [initialForms]="clinicalFormsData"
        [cmsEffectiveStartDate]="cmsEffectiveStartDate"
        [planEffectiveStartDate]="planEffectiveStartDate"
        [hcpcsCode]="code?.code"
        [tenantId]="filters?.tenantId"
        [isLoading]="isLoadingClinicalForms">
      </app-clinical-questionnaire-forms>
    </div>
    
    <!-- Action Buttons -->
    <div class="flex flex-col sm:flex-row gap-3 justify-end pt-4 mt-6" role="group" aria-label="Form actions">
      <ng-container *ngIf="!isEditMode">
        <button type="button"
                pButton 
                label="Edit" 
                icon="pi pi-pencil"
                class="p-button-primary w-full sm:w-auto"
                aria-label="Edit code information"
                *accessView="['CodesMgmt.HCPCS.Write']"
                (click)="toggleEditMode()">
        </button>
      </ng-container>
      
      <button *ngIf="isEditMode" 
              type="button"
              pButton 
              label="Discard Changes" 
              severity="secondary"
              [outlined]="true"
              class="w-full sm:w-auto"
              [disabled]="isSaving"
              [attr.aria-disabled]="isSaving"
              aria-label="Discard changes and return to view mode"
              (click)="onDiscardChanges()">
      </button>
      
      <button *ngIf="isEditMode" 
              type="button"
              pButton 
              label="Save Changes" 
              icon="pi pi-check"
              class="p-button-primary w-full sm:w-auto"
              [disabled]="isSaving || !canSaveCodeChanges"
              [attr.aria-disabled]="isSaving || !canSaveCodeChanges"
              [loading]="isSaving"
              aria-label="Save code changes"
              (click)="onSaveChanges()">
      </button>
    </div>
</div>

<!-- Discard Confirmation Dialog -->
<p-dialog [(visible)]="showDiscardDialog" 
          [modal]="true"
          [closable]="true"
          [style]="{width: '450px'}"
          header="Discard Changes"
          role="alertdialog"
          aria-label="Discard Changes"
          aria-describedby="discard-changes-description">
  <p id="discard-changes-description">You have unsaved changes that will be lost. Are you sure you want to leave this page?</p>
  <ng-template pTemplate="footer">
    <button type="button"
            pButton 
            label="Back" 
            class="p-button-secondary" 
            aria-label="Cancel and return to editing"
            (click)="cancelDiscard()">
    </button>
    <button type="button"
            pButton 
            label="Discard Changes" 
            class="p-button-danger" 
            aria-label="Discard all changes and return to view mode"
            (click)="confirmDiscard()">
    </button>
  </ng-template>
</p-dialog>

<!-- No Clinical Forms Dialog -->
<p-dialog [(visible)]="showNoFormsDialog" 
          [modal]="true"
          [closable]="true"
          [style]="{width: '500px'}"
          role="alertdialog"
          aria-label="No Forms Found"
          aria-describedby="no-forms-description">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-2">
      <i class="pi pi-exclamation-triangle text-yellow-500 text-xl"></i>
      <span class="font-bold text-lg">No Forms Found</span>
    </div>
  </ng-template>
  <p id="no-forms-description">
    This code cannot be saved without any forms.<br/>
    Click Proceed to add a default shared form and save. You can edit, delete, or add additional forms later as needed.
  </p>
  <ng-template pTemplate="footer">
    <button type="button"
            pButton 
            label="Cancel" 
            class="p-button-secondary" 
            aria-label="Cancel and return to editing"
            (click)="cancelNoFormsDialog()">
    </button>
    <button type="button"
            pButton 
            label="Proceed" 
            class="p-button-primary" 
            aria-label="Add default form"
            (click)="proceedWithDefaultForm()">
    </button>
  </ng-template>
</p-dialog>
